import React, { useState } from 'react';
import { FaArrowRight } from 'react-icons/fa'; // Importing the arrow icon from react-icons

const ExclusiveOffers = () => {
  const offers = [
    {
      title: "Stay",
      discount: "30% OFF",
      image: "/images/01.jpg",
    },
    {
      title: "Dine",
      image: "/images/02.jpg",
    },
    {
      title: "Relax",
      discount: "20% OFF",
      image: "/images/03.jpg",
    },
    {
      title: "Weddings",
      image: "/images/04.jpg",
    },
  ];

  const [hoveredIndex, setHoveredIndex] = useState(null); // State to track which card is hovered

  return (
    <div className="container py-5">
      <div className="text-center mb-5">
        <p className="text-warning mb-2">COMFORT & RELAX</p>
        <h2 className="display-5">EXCLUSIVE OFFERS</h2>
      </div>

      <div className="row g-4">
        {offers.map((offer, index) => (
          <div
            key={index}
            className="col-md-3"
            onMouseEnter={() => setHoveredIndex(index)} // Set hovered index when mouse enters
            onMouseLeave={() => setHoveredIndex(null)} // Reset hovered index when mouse leaves
          >
            <div className="position-relative">
              <img
                src={offer.image}
                alt={offer.title}
                className="img-fluid rounded-3"
              />
              {offer.discount && (
                <div className="position-absolute top-0 start-0 m-3 bg-white px-2 py-1 rounded">
                  {offer.discount}
                </div>
              )}

              <div className="position-absolute bottom-0 start-0 m-3 d-flex justify-content-between align-items-center w-100">
                {/* Title on the left */}
                <h3 className="text-white mb-0">{offer.title}</h3>

                {/* Conditionally render the link with Font Awesome arrow on the right */}
                {hoveredIndex === index && (
                  <a
                    href="/"
                    className="text-white text-decoration-none ms-auto bg-primary d-flex justify-content-center align-items-center me-4"
                    style={{
                      height: '40px',
                      width: '40px',
                      borderRadius: '50%',
                      
                    }}
                  >
                    <FaArrowRight className="ms-2" />
                  </a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExclusiveOffers;
